export default "__VITE_ASSET__6b9161e4__"